import { Component, OnInit } from '@angular/core';

import { distinctUntilChanged, map } from 'rxjs/operators';

import MapPercentageFacade from '@app/core/facades/map-percentage.facade';
import { FilterType } from '@app/shared/components/sub-header/filter-type.model';
import FilterChange from '@app/shared/filters/filter-change.model';
import FilterComponent from '@app/shared/filters/filter.component';

const SIZE = '130px';

@Component({
  selector: 'app-filter-map',
  templateUrl: '../filter.component.html',
  styleUrls: ['../filter.component.scss'],
})
export default class MapFilterComponent extends FilterComponent implements OnInit {
  public readonly label = 'MAP %';

  public update(value: number | string, _: boolean): void {
    this._data.updateMapPercentage(value);
    this.valueChange.emit(new FilterChange(FilterType.MapPercentage, value));
  }

  public readonly width = SIZE;

  constructor(private readonly _data: MapPercentageFacade) {
    super();
  }

  ngOnInit() {
    this.options$ = (
      !!this.config.transform ? this.config.transform(this._data.mapPercentages$) : this._data.mapPercentages$
    ).pipe(
      distinctUntilChanged(),
      map((options: Array<{ [key: string]: string | number }>) =>
        options.map((option) => ({ label: `<${option.name}%`, value: option.name }))
      )
    );

    this.initDefaultValues(this._data.mapPercentage$);
  }
}
